/* ======================
   SCRIPT PURIFICATEUR NECESSAIRE AVEC ABONNEMENT
   ====================== */
(() => {
  const PURIFIER_ID  = 10760331493707;
  const RENEWAL_ID   = 10831185740107;

  const RENEWAL_PDP_URL       = 'https://eaunna.fr/products/renouvellement-media';
  const RENEWAL_WITH_PLAN_URL = 'https://eaunna.fr/products/renouvellement-media?selling_plan=689973854539&variant=53274548896075';

  const PDP_BLOCK_SELECTOR  = `.buy-buttons-block[product-id="${PURIFIER_ID}"]`;
  const DRAWER_CHECKOUT_SEL = '.cart__checkout-button.button';

  const hasIdMatch = (item, targetId) => item?.id === targetId || item?.product_id === targetId;

  const getCart = async () => {
    const res = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  };

  const flagsFromCart = (cart) => {
    let hasPurifier = false, hasRenewal = false;
    for (const it of cart.items || []) {
      if (hasIdMatch(it, PURIFIER_ID)) hasPurifier = true;
      if (hasIdMatch(it, RENEWAL_ID))  hasRenewal  = true;
      if (hasPurifier && hasRenewal) break;
    }
    return { hasPurifier, hasRenewal };
  };

  const saveFlagsCache = (flags) => {
    try { localStorage.setItem('eaunna_cart_flags_v1', JSON.stringify(flags)); } catch (e) {}
  };

  const removeAllGuards = () => {
    document.documentElement.classList.remove('eaunna-guard-pdp');
    document.documentElement.classList.remove('eaunna-guard-drawer');
  };

  const MARK = 'data-eaunna-override';

  // PDP: remplacer le CTA si un Purificateur est au panier
  function overridePdpCtaIfNeeded(flags) {
    const block = document.querySelector(PDP_BLOCK_SELECTOR);
    if (!block) return;
    if (!flags.hasPurifier) return;
    if (block.getAttribute(MARK) === 'true') return;

    const link = document.createElement('a');
    link.className = 'button';
    link.setAttribute('role', 'button');

    if (flags.hasPurifier && flags.hasRenewal) {
      // Cas Purificateur + Abonnement
      link.textContent = 'Vous avez déjà sélectionné un abonnement';
      link.setAttribute('aria-label', 'Vous avez déjà sélectionné un abonnement');
      link.href = '#'; // pas de redirection
      link.addEventListener('click', e => e.preventDefault()); // désactive le clic
    } else {
      // Cas Purificateur seul
      link.textContent = 'Sélectionner mon abonnement';
      link.setAttribute('aria-label', 'Sélectionner un abonnement');
      link.href = RENEWAL_PDP_URL;
    }

    block.innerHTML = '';
    block.appendChild(link);
    block.setAttribute(MARK, 'true');
    block.style.visibility = 'visible';
  }

  // Drawer: remplacer le bouton checkout seulement si Purificateur SANS Abonnement
  function overrideDrawerCtaIfNeeded(flags) {
    if (!(flags.hasPurifier && !flags.hasRenewal)) return;

    const checkoutBtn = document.querySelector(DRAWER_CHECKOUT_SEL);
    if (!checkoutBtn || checkoutBtn.getAttribute(MARK) === 'true') return;

    const link = document.createElement('a');
    link.href = RENEWAL_WITH_PLAN_URL;
    link.className = checkoutBtn.className;
    link.textContent = 'Merci de sélectionner un abonnement';
    link.setAttribute('aria-label', 'Merci de sélectionner un abonnement');

    checkoutBtn.replaceWith(link);
    link.setAttribute(MARK, 'true');
  }

  async function run() {
    try {
      const cart  = await getCart();
      const flags = flagsFromCart(cart);

      saveFlagsCache(flags);

      overridePdpCtaIfNeeded(flags);
      overrideDrawerCtaIfNeeded(flags);

      removeAllGuards();
    } catch (e) {
      removeAllGuards();
    }
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', run);
  document.addEventListener('cart:refresh', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('drawer:open', run);

  const mo = new MutationObserver(() => run());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ======================
   REFRESH PAGE APRÈS ADD-TO-CART (sans double-ajout)
   ====================== */
(() => {
  const PURIFIER_ID = 10760331493707;
  const PDP_BLOCK_SELECTOR = `.buy-buttons-block[product-id="${PURIFIER_ID}"]`;

  let reloadAfterAdd = false;

  const fetchJSON = (url, opts = {}) =>
    fetch(url, { credentials: 'same-origin', cache: 'no-store', ...opts })
      .then((r) => { if (!r.ok) throw new Error(`${url} ${r.status}`); return r.json(); });

  const hardReload = () => { try { location.reload(); } catch (_) { location.href = location.href; } };

  const onSubmitReload = async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    reloadAfterAdd = true;
    const isThemeAjax = form.matches('[data-ajax-add], .js-product-form, .product-form') ||
                        form.hasAttribute('data-product-form');

    e.preventDefault();

    if (!isThemeAjax) {
      const submitter = e.submitter || document.activeElement || form.querySelector('[type="submit"], [name="add"]');
      const prevText = submitter ? submitter.textContent : '';
      if (submitter) submitter.disabled = true;

      try {
        const body = new FormData(form);
        await fetchJSON('/cart/add.js', { method: 'POST', body });
        hardReload();
      } catch (err) {
        console.error('[add-to-cart reload]', err);
        alert("Ajout au panier impossible. Merci de réessayer.");
        if (submitter) submitter.disabled = false, submitter.textContent = prevText;
        reloadAfterAdd = false;
      }
    }
  };

  const onAddButtonClick = () => {
    reloadAfterAdd = true; // on attend l'event du thème
  };

  document.addEventListener('cart:updated', () => {
    if (reloadAfterAdd) hardReload();
  });

  const findProductForm = () => {
    const block = document.querySelector(PDP_BLOCK_SELECTOR);
    if (block) {
      const inBlock = block.querySelector('form[action^="/cart/add"]');
      if (inBlock) return inBlock;

      const near = block.closest('section, div, form')?.querySelector('form[action^="/cart/add"]');
      if (near) return near;
    }
    const all = document.querySelectorAll('form[action^="/cart/add"]');
    if (all.length === 1) return all[0];
    for (const f of all) {
      if (f.querySelector('input[name="id"]')) return f;
    }
    return null;
  };

  const bindOnPdp = () => {
    if (!document.querySelector(PDP_BLOCK_SELECTOR)) return;

    const form = findProductForm();
    if (form && !form.__eaunnaReloadSubmitBound) {
      form.addEventListener('submit', onSubmitReload, { capture: true });
      form.__eaunnaReloadSubmitBound = true;
    }

    const buttons = [
      '[name="add"]',
      'button[type="submit"]',
      'button.add-to-cart',
      '.product-form__submit',
      '[data-add-to-cart]',
    ];
    for (const sel of buttons) {
      document.querySelectorAll(sel).forEach((btn) => {
        if (btn.__eaunnaReloadClickBound) return;
        if (form && !form.contains(btn)) return;
        btn.addEventListener('click', onAddButtonClick, { capture: true });
        btn.__eaunnaReloadClickBound = true;
      });
    }
  };

  document.addEventListener('DOMContentLoaded', bindOnPdp);
  const mo = new MutationObserver(bindOnPdp);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ======================
   REFRESH PAGE APRÈS SUPPRESSION DANS LE PANIER
   ====================== */
(() => {
  let reloadAfterRemove = false;

  const fetchJSON = (url, opts = {}) =>
    fetch(url, { credentials: 'same-origin', cache: 'no-store', ...opts })
      .then((r) => { if (!r.ok) throw new Error(`${url} ${r.status}`); return r.json(); });

  const hardReload = () => { try { location.reload(); } catch (_) { location.href = location.href; } };

  document.addEventListener('cart:updated', () => {
    if (reloadAfterRemove) hardReload();
  });

  const findLineFromButton = async (btn) => {
    const form = btn.closest('form[action*="/cart/change"]');
    if (form) return { form };

    const withLine = btn.closest('[data-line]') || btn;
    const line = withLine.dataset ? withLine.dataset.line : null;
    if (line) return { line: parseInt(line, 10) };

    const withVar = btn.closest('[data-variant-id]') || btn;
    const variantId = withVar.dataset ? withVar.dataset.variantId : null;
    if (variantId) {
      const cart = await fetchJSON('/cart.js');
      const index = (cart.items || []).findIndex(i => String(i.id) === String(variantId));
      if (index >= 0) return { line: index + 1 };
    }

    return {};
  };

  const onRemoveClick = async (e) => {
    const btn = e.currentTarget;
    reloadAfterRemove = true;
    let prevented = false;

    try {
      const { form, line } = await findLineFromButton(btn);

      if (form) {
        e.preventDefault(); prevented = true;
        const fd = new FormData(form);
        const action = '/cart/change.js';
        await fetchJSON(action, { method: 'POST', body: fd });
        hardReload();
        return;
      }

      if (line) {
        e.preventDefault(); prevented = true;
        const fd = new FormData();
        fd.append('line', String(line));
        fd.append('quantity', '0');
        await fetchJSON('/cart/change.js', { method: 'POST', body: fd });
        hardReload();
        return;
      }

      // sinon: laisser le thème gérer, on attendra cart:updated
    } catch (err) {
      console.error('[cart remove fallback]', err);
      alert('Suppression impossible. Merci de réessayer.');
      reloadAfterRemove = false;
    } finally {
      if (!prevented) {
        setTimeout(() => {
          if (reloadAfterRemove) hardReload();
        }, 1200);
      }
    }
  };

  const bindRemoveButtons = () => {
    document.querySelectorAll('button.cart-items__remove, .cart-items__remove').forEach((btn) => {
      if (btn.__eaunnaRemoveBound) return;
      btn.addEventListener('click', onRemoveClick, { capture: true });
      btn.__eaunnaRemoveBound = true;
    });
  };

  document.addEventListener('DOMContentLoaded', bindRemoveButtons);
  const mo = new MutationObserver(bindRemoveButtons);
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
